<template>
    <v-form v-model="form" ref="form_step_2">
        <v-row>
            <v-col cols="12" style="min-height: 400px">
                <renters-simple-list class="mt-5 mb-5"></renters-simple-list>
                <additional-information-input  v-if="notes_on_kiosk"></additional-information-input>
                <h5 class="mt-15 font-weight-bold error--text text-break">
                    Please check any of the individual reservations above, if correct, push "continue" to move to the checkout page.
                </h5>
            </v-col>
        </v-row>
        <steps-navigation   :error-messages-list="errorMessagesList"
                            :errors="v__getErrors()"
                            next-button="Continue"
                            @step-next="stepNext()"
                            @step-back="stepBack({validate:false,submit:false})">
        </steps-navigation>

      <v-dialog v-model="messageDialog.show" persistent max-width="800px">
        <DoneMessageModal :message="messageDialog.message" :success="messageDialog.success"></DoneMessageModal>
      </v-dialog>
    </v-form>
</template>

<script>
import DoneMessageModal               from "../../../components/modals/DoneMessageModal";
import AdditionalInformationInput from "../../../components/partials/AdditionalInformationInput";
import RentersSimpleList          from "../../../components/partials/RentersSimpleList";
import StepsNavigation            from "../../../components/partials/StepsNavigation";
import {mapActions, mapGetters}               from "vuex";
import StepperComponentMixin      from "../../../mixins/StepperComponentMixin";
import ValidatableComponent       from "../../../mixins/ValidatableComponent";
import PaymentWidget              from "./step3/PaymentWidget";
import step_2                     from "../validation/step_2";
import cc_form__rules from "../../../validation/scenarios/cc_form__rules";

export default {
    name      : "Step2",
    components: {AdditionalInformationInput, StepsNavigation, RentersSimpleList, PaymentWidget, DoneMessageModal},
    mixins    : [StepperComponentMixin,ValidatableComponent],
    data      : () => ({
        form: false,
        messageDialog: {
          show   : false,
          message: '',
          success: true
        },
        errorMessagesList: [],
        errorStatus: false,
    }),
    methods   : {
        ...mapActions(['do_save_reservee', 'do_calculate_kiosk_cost', 'do_save_swipe_kiosk', 'do_save_renter_information_kiosk', 'do_save_seasonal_renter_information_kiosk', 'do_complete_reservation']),

      async stepSubmit() {
        //   this.$store.state.disabled_status = true;
        if(this.$store.state.model.reservees.length!==0){
            const reservee_result = await this.do_save_reservee();
            if(reservee_result.status && reservee_result.status===200){
                await this.do_calculate_kiosk_cost();
                if((window.location.href.includes('prepay') && (this.prepay_payment || this.only_save_card_at_prepay)) || (this.is_seasonal && !window.location.href.includes('seasonal') && (this.full_charge_at_seasonal_kiosk || this.credit_card_swipe_kiosk)) || (this.is_seasonal && window.location.href.includes('seasonal') && (this.full_charge_at_seasonal_advance_on || this.save_card_at_seasonal_advance_on)) || (!this.is_seasonal && (this.full_charge_at_kiosk || this.swipeMode))){
                    if(!this.rechapcha_is_checked && this.$store.state.resources.config.google_recaptcha=="1" && this.$store.state.resources.config.google_recaptcha_site_key!=''){
                       if(!this.$store.state.model.cost.free_checkout){
                            this.$store.commit('set_disabled_status', true);
                       }
                    }
                }
                    
                // this.$store.state.disabled_status = false;
                return true;
                // const result = await this.do_save_swipe_kiosk();
                // if(result.data.success === false || result.status !== 200){
                //     this.errorMessagesList = [result.data.message.includes(":")?result.data.message.split(":")[1]:result.data.message];
                //     this.errorStatus = true;
                // } else {
                //     this.errorMessagesList = [];
                //     this.errorStatus = false;
                //     if((!this.is_seasonal && this.full_charge_at_kiosk) || (this.is_seasonal && this.full_charge_at_seasonal_kiosk)){
                //         this.$store.state.disabled_status = false;
                //         return true;
                //     }
                // }
                // if(!this.errorStatus){
                //     if(!this.is_seasonal && !this.full_charge_at_kiosk){
                //         await this.do_save_renter_information_kiosk();
                //     }
                //     if(this.is_seasonal && !this.full_charge_at_seasonal_kiosk){
                //         await this.do_save_renter_information_kiosk();
                //     }
                //     await this.do_complete_reservation();
                //     this.showMessage();
                // }
            }else{
                this.errorMessagesList[0] = reservee_result.data.message;
            }
        }else{
            this.errorMessagesList[0] = "Please add a renter!";
        }
        //   this.$store.state.disabled_status = false;

      },
        showMessage(success) {
          this.messageDialog.message = this.thankYouText;
          this.messageDialog.success = success === undefined ? true : success;
          this.messageDialog.show = true;
          const self = this;
          setTimeout(function(){
            self.messageDialog.show = false;
            self.reload();
          },4000);
        },
        reload(){
          window.localStorage.removeItem('last_reservation_id');
          window.location.reload();
        }
    },
    computed  : {
        amount_to_be_paid() {
            return this.$store.state.model.cost.amount_to_be_paid;
        },
        reservation() {
            return this.$store.state.model.reservation;
        },
        swipeMode() {
            return parseInt(this.$store.state.resources.config.credit_card_swipe);
        },
        credit_card_swipe_kiosk() {
            return parseInt(this.$store.state.resources.config.credit_card_swipe_kiosk);
        },
        full_charge_at_kiosk() {
          return parseInt(this.$store.state.resources.config.full_charge_at_kiosk);
        },
        full_charge_at_seasonal_kiosk() {
            return parseInt(this.$store.state.resources.config.full_charge_at_seasonal_kiosk);
        },
        is_seasonal(){
            return this.$store.state.model.reservation.is_seasonal;
        },
        thankYouText() {
          return this.$store.state.resources.kiosk_config.thankYouText.content;
        },
        notes_on_kiosk(){
            return parseInt(this.$store.state.resources.config.notes_on_kiosk);
        },
        prepay_payment(){
            return parseInt(this.$store.state.resources.config.prepay_payment);
        },
        only_save_card_at_prepay(){
            return parseInt(this.$store.state.resources.config.only_save_card_at_prepay);
        },
        is_seasonal(){
            return parseInt(this.$store.state.model.reservation.is_seasonal);
        },
        full_charge_at_seasonal_kiosk() {
            return parseInt(this.$store.state.resources.config.full_charge_at_seasonal_kiosk);
        },
        seasonal_kiosk_payment_checkout() {
            return parseInt(this.$store.state.resources.config.credit_card_swipe_kiosk);
        },
        full_charge_at_seasonal_advance_on(){
            return parseInt(this.$store.state.resources.config.full_charge_at_seasonal_advance_on);
        },
        save_card_at_seasonal_advance_on(){
            return parseInt(this.$store.state.resources.config.save_card_at_seasonal_advance_on);
        },
        full_charge_at_kiosk() {
            return parseInt(this.$store.state.resources.config.full_charge_at_kiosk);
        },
        swipeMode() {
            return parseInt(this.$store.state.resources.config.credit_card_swipe);
        },
        ...mapGetters(['rechapcha_is_checked'])
    },
    mounted() {
        const self = this;
        this.withValidation({
            getModel() {
                return self.$store.state.model;
            },
            rules : step_2,
            fields: {}
        });

        this.withValidation({
            getModel() {
                return self.$store.state.model.payment;
            },
            fields: {}
        })
    }
}
</script>

<style scoped>

</style>
